module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/edit-icon.13e4e5b8.svg";